<template>
  <div
    class="modal fade"
    id="herstellerModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="herstellerModalTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="herstellerModalTitle">Herstellerinfos</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            <b>Lütfrink Technische Federn GmbH</b>
            <br />Schwanenschlatt 12
            <br />46499 Hamminkeln-Dingden
            <br />Deutschland
            <br />Telefax: + 49 – 28 52 – 71 11 26
          </p>
          <p>
            <a href="mailto:info@luetfrink.de" class="support-a">
              <i class="fa fa-envelope" style="font-size: 20px; width: 40px"></i>
              E-Mail: info@luetfrink.de
            </a>
          </p>
          <p>
            <a href="tel:+4928712372566" class="support-a">
              <i class="fa fa-phone" style="font-size: 20px; width: 40px"></i>
              Telefon: + 49 – 28 52 – 71 11 16
            </a>
          </p>
          <p>
            <a href="http://www.luetfrink.de" class="support-a">
              <i class="fa fa-phone" style="font-size: 20px; width: 40px"></i>
              Internet: www.luetfrink.de
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "HerstellerModal",
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

